import { Edit, useRecordContext } from "react-admin";
import { WayOfArrivalForm } from "./form";

const WayOfArrivalEditTitle = () => {
  const record = useRecordContext();
  return <span>Edit {record ? `"${record.value}"` : ""}</span>;
};

export const WayOfArrivalEdit = () => (
  <Edit title={<WayOfArrivalEditTitle />}>
    <WayOfArrivalForm />
  </Edit>
);
